import {
  car_series,
  car_series_all,
  car_group,
  car_group_all,
  car_kind,
  car_kind_all,
  car_kindFile,
  car_icon,
  car_iconFile,
  equip_type,
  equip_type_unique,
  language_list,
  language_list_all,
  all_language_list,
  all_language_list_all,
  equip_model,
  equip_xinghao,
  equip_user,
  mobile_equip,
  authoriz_carModel,
  unauthoriz_carModel,
  model_dataPackage,
  fileInfo_list,
  fileInfo_all,
  fileVersion_list,
  authoriz_expandFile,
  otherfile_list,
  otherfile_list_id,
  otherfile_ver_list,
  otherfile_ChildPage,
  brand_list,
  brand_unauth_list,
  brand_auth_list,
  appeal_list,
  getCheckTypeList,
  languagefile_list
} from './../assets/ajax/api'

export default {
  //车系分页列表
  getCar_series(context, a) {
    car_series(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },
  //获取所有车系
  getCar_series_all(context, a) {
    car_series_all(a).then(response => {
      console.log('responseeee',response)
      context.commit('setCarSeries', response.data)
    })
  },

  //车组分页列表
  getCar_group(context, a) {
    car_group(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },
  //获取车系下所有车组
  getCar_group_all(context, a) {
    console.log(context,a,'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
    car_group_all(a.carClassID).then(response => {
      console.log('response',response)
      context.commit('setCarGroup', response.data)
    })
  },
  //获取车系下所有车组
  getCar_group_all1(context, a) {
    console.log(context,a,'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
    car_group_all(a).then(response => {
      console.log('response',response)
      context.commit('setCarGroup', response.data)
    })
  },
  //  车型文件获取车系下所有车组
  getCar_group_alls(context, a) {
    console.log(context,a,'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
    car_group_all(a).then(response => {
      console.log('response',response)
      context.commit('setCarGroup', response.data)
    })
  },

  //获取车型列表
  getCar_kind(context, a) {
    car_kind(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },
  //获取车组下所有车型
  getCar_kind_all(context, a) {
    console.log(context,a,'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
    car_kind_all(a).then(response => {
      context.commit('setCarKind', response.data)
    })
  },
  //获取车型文件列表
  getCar_kindFile(context, a) {
    car_kindFile(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },
  //获取车标类型列表
  getCar_icon(context, a) {
    car_icon(a).then(response => {
      context.commit('setTableData', response.data)
    })
  },
  //获取车标图标列表
  getCar_iconList(context, a) {
    car_icon(a).then(response => {
      context.commit('setIconList', response.data)
    })
  },

  //获取车标文件列表
  getCar_iconFile(context, a) {
    car_iconFile(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },


  //获取所有售机类型列表
  get_equipType_all(context, a) {
    equip_type(a).then(response => {
      context.commit('setEquipType', response.data)
    })
  },
  //获取所有售机类型列表(去掉重复路径)
  get_equipTypeUnique_all(context, a) {
    equip_type_unique(a).then(response => {
      context.commit('setEquipTypeUnique', response.data)
    })
  },
  //获取所有设备机型列表
  get_equipModel(context, a) {
    equip_model(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },

  //获取某个设备机型的所有授权车型列表
  get_authoriz_carModel(context, a) {
    authoriz_carModel(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },
  //获取某个设备机型的所有未授权车型列表
  get_unauthoriz_carModel(context, a) {
    unauthoriz_carModel(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },

  //获取用户设备列表
  get_equip_user(context, a) {
    equip_user(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },
  //获取手机设备列表
  get_mobile_equip(context, a) {
    mobile_equip(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },


  //获取商用车车型数据包列表
  get_model_dataPackage(context, a) {
    model_dataPackage(a).then(response => {
      context.commit('setTableData', response.data)
    })
  },

  //获取扩展文件信息列表
  get_fileInfo_list(context, a) {
    fileInfo_list(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },
  //获取扩展文件信息列表(下拉框)
  get_fileInfo_all(context, a) {
    fileInfo_all(a).then(response => {
      context.commit('setFileInfoAll', response.data)
    })
  },
  //获取扩展文件版本列表
  get_fileVersion_list(context, a) {
    fileVersion_list(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },
  //获取语言列表
  get_language_list(context, a) {
    language_list(a).then(response => {
      context.commit('setLanguageList', response.data)
    })
  },
  //获取语言项列表（包含all项）
  get_language_listAll(context, a) {
    language_list_all(a).then(response => {
      context.commit('setLanguageListAll', response.data)
    })
  },
  //获取所有语言列表
  get_language_all(context, a) {
    all_language_list(a).then(response => {
      context.commit('setLanguageAll', response.data)
    })
  },
  //获取所有语言列表(包含all项)
  get_language_list_all(context, a) {
    all_language_list_all(a).then(response => {
      context.commit('setAllLanguageAll', response.data)
    })
  },
  //获取通用文件类型分页列表
  getOtherfile_list(context, a) {
    otherfile_list(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },
  //获取通用文件类型分页列表
  getOtherfile_list_id(context, a) {
    otherfile_list_id(a).then(response => {
      context.commit('setOtherfileList', response.data)
    })
  },
  //获取通用文件版本分页列表
  getOtherfile_ver_list(context, a) {
    otherfile_ver_list(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },
  //获取通用文件版本分页列表
  getOtherfile_ChildPage(context, a) {
    otherfile_ChildPage(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },
  //获取海外品牌分页列表
  getBrand_list(context, a) {
    brand_list(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },
  //获取海外品牌已授权商用车品牌分页列表
  getBrand_auth_list(context, a) {
    brand_auth_list(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },
  //获取海外品牌未授权商用车品牌分页列表
  getBrand_unauth_list(context, a) {
    brand_unauth_list(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },
  getAppeal_list_list(context, a) {
    console.log('a',a)
    appeal_list(a).then(response => {
      console.log('response',response)
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })
  },
  //获取通用文件类型
  checkType_list(context, a) {
    getCheckTypeList(a).then(response => {
      context.commit('setCheckTypeList', response.data)
    })
  },
  //获取文件类型语言信息(分页)
  getLanguagefile_list(context, a) {
    languagefile_list(a).then(response => {
      context.commit('setTableData', response.data.rows)
      context.commit('setTotal', response.data)
    })

  },
}


// WEBPACK FOOTER //
// ./src/store/actions.js